import { Http_BadRequest, Http_OK } from "../../../../lib/httpStatusCodes";
import { sortJson } from "../../../../lib/sortJson";

const apiUrl = `${process.env.REACT_APP_ADMIN_BASE_URL}group`;
const apiAuthUrl = `${process.env.REACT_APP_AUTH_BASE_URL}user`;

//let apiUrl = `${process.env.REACT_APP_LOCAL_BASE_URL}group`;
//let apiAuthUrl = `http://localhost:7073/api/user`;

//=======================================================================

export const getAllUserGroups = () => {
    return new Promise((resolve, reject) => {
        fetch(`${apiUrl}${process.env.REACT_APP_ADMIN_KEY_CODE}`)
            .then((response) => {
                return new Promise((res, rej) => {
                    switch (response.status) {
                        case Http_BadRequest:
                            response.json().then((json) => {
                                return rej(json.errors);
                            });
                            break;

                        case Http_OK:
                            response.json().then((json) => {
                                let data = sortJson(json.data, "name", "string", true);
                                return res(data);
                            });
                            break;
                        default:
                            rej(`Error loading data (${response.status})`);
                    }
                });
            })
            .then((ret) => resolve(ret))
            .catch((err) => {
                reject(err);
            });
    });
};

//=======================================================================

export const getUserGroupById = (id) => {
    return new Promise((resolve, reject) => {
        fetch(`${apiUrl}/${id}${process.env.REACT_APP_ADMIN_KEY_CODE}`, { method: "GET" })
            .then((response) => {
                return new Promise((res, rej) => {
                    switch (response.status) {
                        case Http_BadRequest:
                            response.json().then((json) => {
                                return rej(json.errors);
                            });
                            break;

                        case Http_OK:
                            response.json().then((json) => {
                                return res(json.data);
                            });
                            break;
                        default:
                            rej(`Error to fetch data (${response.status})`);
                    }
                });
            })
            .then((ret) => resolve(ret))
            .catch((err) => reject(err));
    });
};

//=======================================================================

export const getAllUsers = () => {
    return new Promise((resolve, reject) => {
        fetch(`${apiAuthUrl}${process.env.REACT_APP_AUTH_KEY_CODE}`)
            .then((response) => {
                return new Promise((res, rej) => {
                    switch (response.status) {
                        case Http_BadRequest:
                            response.json().then((json) => {
                                return rej(json.errors);
                            });
                            break;

                        case Http_OK:
                            response.json().then((json) => {
                                let data = sortJson(json.data, "name", "string", true);
                                return res(data);
                            });
                            break;
                        default:
                            rej(`Error loading data (${response.status})`);
                    }
                });
            })
            .then((ret) => resolve(ret))
            .catch((err) => {
                reject(err);
            });
    });
};

//=======================================================================

export const createUserGroups = (data) => {
    return new Promise((resolve, reject) => {
        fetch(`${apiUrl}${process.env.REACT_APP_ADMIN_KEY_CODE}`, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
        })
            .then((response) => {
                return new Promise((res, rej) => {
                    switch (response.status) {
                        case Http_BadRequest:
                            response.json().then((json) => {
                                return rej(json.errors);
                            });
                            break;

                        case Http_OK:
                            response.json().then((json) => {
                                return res(json.data);
                            });
                            break;
                        default:
                            rej(`Error to create data (${response.status})`);
                    }
                });
            })
            .then((ret) => resolve(ret))
            .catch((err) => reject(err));
    });
};

//=======================================================================

export const updateUserGroups = (data) => {
    return new Promise((resolve, reject) => {
        fetch(`${apiUrl}/${data?.id}${process.env.REACT_APP_ADMIN_KEY_CODE}`, {
            method: "PUT",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
        })
            .then((response) => {
                return new Promise((res, rej) => {
                    switch (response.status) {
                        case Http_BadRequest:
                            response.json().then((json) => {
                                return rej(json.errors);
                            });
                            break;

                        case Http_OK:
                            response.json().then((json) => {
                                return res(json.data);
                            });
                            break;
                        default:
                            rej(`Error to create data (${response.status})`);
                    }
                });
            })
            .then((ret) => resolve(ret))
            .catch((err) => reject(err));
    });
};

//=======================================================================

export const deleteUserGroups = (id) => {
    return new Promise((resolve, reject) => {
        fetch(`${apiUrl}/${id}${process.env.REACT_APP_ADMIN_KEY_CODE}`, { method: "DELETE" })
            .then((response) => {
                return new Promise((res, rej) => {
                    switch (response.status) {
                        case Http_BadRequest:
                            response.json().then((json) => {
                                return rej(json.errors);
                            });
                            break;

                        case Http_OK:
                            response.json().then((json) => {
                                return res(json.data);
                            });
                            break;
                        default:
                            rej(`Error to delete data (${response.status})`);
                    }
                });
            })
            .then((ret) => resolve(ret))
            .catch((err) => reject(err));
    });
};

//=======================================================================
